import { toast } from 'sonner';

/**
 * Confirmation toast for critical / irreversible operations
 * (delete, edit-save, activate/inactivate, approve, reject, etc.).
 *
 * Shows a sonner toast with an explicit Confirm action and a Cancel button.
 * Doing nothing auto-dismisses without performing the action (safe default).
 *
 * confirmToast({
 *   message: 'Delete this record?',
 *   description: 'This cannot be undone.',
 *   confirmLabel: 'Delete',
 *   destructive: true,
 *   onConfirm: async () => { ... },
 * });
 */
export function confirmToast({
  message,
  description,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  destructive = false,
  onConfirm,
  onCancel,
}) {
  const show = destructive ? toast.warning : toast;
  show(message, {
    description,
    duration: 10000,
    action: {
      label: confirmLabel,
      onClick: () => {
        try {
          const r = onConfirm && onConfirm();
          if (r && typeof r.then === 'function') r.catch(() => {});
        } catch (_) { /* handled by caller */ }
      },
    },
    cancel: {
      label: cancelLabel,
      onClick: () => { if (onCancel) onCancel(); },
    },
  });
}

export default confirmToast;
